import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import TargetService from '../../../services/target-service/TargetService'
import BaseSelect from '../../selects/base-select/BaseSelect'
// import Help from '../help/Help'

const TargetSelect = props => {
    const optionsInitialValue = [
        {
            name: 'SELECIONE UM OPÇÃO',
            value: 'no_opt',
            disabled: true,
            selected: true,
        },
    ]
    const [targets, setTargets] = useState([])
    const [options, setOptions] = useState(optionsInitialValue)
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        fetchTargets()
    }, [])

    useEffect(() => {
        const optionList = TargetService.getOptions(targets)
        setOptions(optionList)
    }, [targets])

    const fetchTargets = async () => {
        try {
            const targets = await TargetService.findTargets()
            setTargets(targets)
        } catch (e) {
            setHasError(true)
            console.error('Error: ', e)
        }
    }

    return (
        <>
            {hasError ? (
                <div>Não foi possível carregar as opções de target.</div>
            ) : (
                <BaseSelect className="w-50" name="target" options={options} {...props} />
            )}

            {/* Decomentar quando for add os target na documentação */}
            {/* &nbsp; &nbsp;
            <Help
                id={'register-help-target'}
                onclick={() => window.open('https://ame-app-tools.calindra.com.br/docs/cli/#start', '_blank')}
            /> */}
        </>
    )
}

TargetSelect.propTypes = {
    onchange: PropTypes.func,
    targetValue: PropTypes.string,
    invalid: PropTypes.bool,
}

export default TargetSelect
